$(document).ready(function () {
  var brandsList = $("[data-collection-list]"),
    brand = brandsList.find(".brand");

  brand.each(function () {
    var self = $(this),
      brandTitle = self.find(".azbrands-title h3").text().trim(),
      character = self
        .find("ul.brand-grid li:eq(0) a")
        .text()
        .charAt(0)
        .toLowerCase(),
      alphabet = brandsList.prev(),
      alphabetChild = alphabet.children();

    alphabetChild.each(function () {
      var aElm = $(this).find("a");

      if (aElm.text().trim().toLowerCase() == brandTitle) {
        if (!aElm.hasClass("readonly")) aElm.addClass("readonly");
        return;
      }
    });
    if (!self.find(".azbrands-title").length) {
      console.log(character);
      self
        .find(".brand-grid")
        .children()
        .appendTo(".brand-" + character + " ul.brand-grid");
      self.remove();
    }
  });

  var vendorItem = brandsList.prev().find(".vendor-letter a.readonly");

  vendorItem.on("click", function () {
    var selfText = $(this).text().trim().toLowerCase();

    brand.hide().filter(function (e) {
      var title = $(this)
        .find(".azbrands-title h3")
        .text()
        .trim()
        .toLowerCase();

      if (title == selfText) {
        $(this).show();
        return;
      }
    });

    $(".azbrandstable .all-brand a").click(function () {
      brand.show();
    });
  });

  var allVendor = brandsList.prev().find("a.readonly");

  allVendor.on("click", function () {
    brandsList.prev().find("a").removeClass("active");

    var self = $(this);

    if (!self.hasClass("active")) {
      self.addClass("active");
    }
  });
});
